import React from 'react';
import { TextField, MenuItem } from '@mui/material';

export const MultiSelectBlock = ({ setting, onValueChange, controlSize = 'small', fullWidth = false }) => {
    const handleChange = (event) => {
        onValueChange(
            setting.id,
            event.target.value.join(","),
            setting.parameter_type
        );
    };

    return (
        <TextField
            select
            disabled={!setting.is_active}
            SelectProps={{
                multiple: true,
                value: setting.parameter_value
                    ? setting.parameter_value.split(",")
                    : [],
                onChange: handleChange,
            }}
            variant="outlined"
            size={controlSize}
            fullWidth={fullWidth}
        >
            {setting.options?.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                    {option.label}
                </MenuItem>
            ))}
        </TextField>
    );
};
